import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import CTAButton from './CTAButton';
import CalendlyWidget from '@/components/shared/CalendlyWidget';

interface CalendlyScheduleDialogProps {
  triggerText?: string;
  className?: string;
  fullWidthMobile?: boolean;
}

const CalendlyScheduleDialog: React.FC<CalendlyScheduleDialogProps> = ({ 
  triggerText = 'Schedule Us',
  className = '',
  fullWidthMobile = true
}) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <CTAButton className={className} fullWidthMobile={fullWidthMobile}>
          {triggerText}
        </CTAButton>
      </DialogTrigger>
      <DialogContent className="bg-maintenance-navy text-white border-white max-w-[95vw] sm:max-w-[90vw] md:max-w-3xl lg:max-w-4xl xl:max-w-5xl p-0 max-h-[95vh] sm:max-h-[90vh]">
        <DialogHeader className="px-4 sm:px-6 pt-4 sm:pt-6 pb-2">
          <DialogTitle className="text-white text-xl sm:text-2xl">
            Schedule a Visit
          </DialogTitle>
          <DialogDescription className="text-gray-300 text-sm sm:text-base">
            Choose a convenient time to schedule a visit with our team
          </DialogDescription>
        </DialogHeader>
        <div className="px-4 sm:px-6 pb-4 sm:pb-6">
          <CalendlyWidget
            isActive={isOpen}
            style={{
              height: '70vh',
              maxHeight: '700px',
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CalendlyScheduleDialog;

